import { VendorAuthContext } from "@redotech/redo-marketplace-app-common/vendor-auth";
import { memo, useContext } from "react";
import { Outlet, useNavigate } from "react-router-dom";

export const BrandsLayout = memo(function BrandsLayout() {
  const vendorAuth = useContext(VendorAuthContext);
  const navigate = useNavigate();

  if (!vendorAuth) {
    navigate("/");
    return null;
  }

  return (
    <div className="h-full w-full">
      <Outlet />
    </div>
  );
});
